import { Type } from "js-yaml";
class ParsedData {
  key;
  constructor(key) {
    this.key = key;
  }
}
const DataTag = new Type("!data", {
  kind: "scalar",
  resolve: (data) => data !== null && typeof data === "string",
  construct: (data) => new ParsedData(data),
  instanceOf: ParsedData,
  represent: (data) => data.key
});
export {
  DataTag,
  ParsedData
};
